import f from "../funcs";
import $ from "jquery";
import "plugins/hasChild";


let index = 0;
let newId = function() {
    return ++index;
};

$.fn.filesDrop = function(emitter) {
    return this.each(function() {
        let $box = $(this);
        // emitter - объект, который участвует в приеме файлов
        // он получит событие filesUpload

        if ( emitter == "destroy" ) {
            $box.off(".filesDrop");
            $box.children(".files-drag-over-layer").remove();
            $(window).off(".filesDrop" + $box.data("filesDropId"));
            return;
        }

        let $layer = $box.children(".files-drag-over-layer");
        if ( !$layer.length ) {
            $layer = $("<div class='files-drag-over-layer theme-border-color theme-color--before'></div>").appendTo($box);
        }

        let box = $box.get(0);

        let id = newId();
        $box.data("filesDropId", newId());

        $box.on("dragleave.filesDrop", function(e) {
            // когда уходит из окна

            if ( e.eventPhase == 3 ) {
                let windowSize = f.getWindowSize();
                let point = f.getMousePoint(e);

                if (
                    point.x < windowSize.width - 100
                        && point.x > 100
                        && point.y < windowSize.height - 100
                        && point.y > 100
                ) {
                    return;
                }

                $(".files-drag-over").removeClass("files-drag-over");
            }
        });

        $(window).on("dragover.filesDrop" + id, function(e) {
            if ( !$box.hasClass("files-drag-over") ) {
                return;
            }

            // проверяем местоположение событие
            let toElement = e.target;
            let $toElement = $(toElement);

            if ( $box.hasChild($toElement) || toElement == box ) {
                return;
            }

            $box.removeClass("files-drag-over");
        });

        $box.on("drop.filesDrop", function(e) {
            e.stopPropagation();
            e.preventDefault();
            $box.removeClass("files-drag-over");

            let files = e.originalEvent.dataTransfer.files;
            if ( !files || files.length === 0 ) {
                return;
            }

            emitter.onFilesDrop({
                event: e,
                $box,
                emitter,
                files
            });
        });

        $box.on("dragenter.filesDrop", function(e) {
            e.stopPropagation();
            e.preventDefault();
            $(".files-drag-over").removeClass("files-drag-over");
            $box.addClass("files-drag-over");

            if ( box.offsetHeight < 100 ) {
                $layer.addClass("small");
            } else {
                $layer.removeClass("small");
            }
        });

        // отменяем событие по умолчание, чтобы браузер не перезагрузил страницу
        $box.on("dragover.filesDrop dragleave.filesDrop", function(e) {
            e.stopPropagation();
            e.preventDefault();
        });
    });
};

export default $.fn.filesDrop;
